'use strict';

import angular from 'angular';

export default angular.module('storageApp.filters.number', [])
  .filter('hexDigit', function(Storage){
    'ngInject';

    return function (input) {
      var n  = Number(input);
      var b1 = Number(0xFF&(n >> 16));
      var b2 = Number(0xFF&(n >> 8));
      var b3 = Number(0xFF&n);

      var x1 = b1.toString(16).toUpperCase();
      var x2 = b2.toString(16).toUpperCase();
      var x3 = b3.toString(16).toUpperCase();

      if(x1.length < 2) x1 = '0' + x1;
      if(x2.length < 2) x2 = '0' + x2;
      if(x3.length < 2) x3 = '0' + x3;

      return '0x' + x1 + x2 + x3;
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/filters/number.js